<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Status Treinamento
        </p>
      </div>
    </div>
    <div class="row col-12 q-mt-sm q-mb-lg q-gutter-sm">
      <div class="col">
        <div>
          <q-card flat class="card-2">
            <div class="row q-pa-md">
              <div class="row col-12 q-mb-lg">
                <span class="text-subtitle1 row col-12 text-white"
                  >Vencidos
                </span>
              </div>
              <div class="row col-12 justify-between q-mb-lg items-center">
                <div>
                  <q-icon size="40px" name="highlight_off" color="white" />
                </div>
                <div>
                  <span class="text-h6 text-white">{{
                    highlights.vencido
                  }}</span>
                </div>
              </div>
            </div>
          </q-card>
        </div>
      </div>
      <div class="col">
        <div>
          <q-card flat class="card-3">
            <div class="row q-pa-md">
              <div class="row col-12 q-mb-lg">
                <span class="text-subtitle1 row col-12 text-white"
                  >Válidos</span
                >
              </div>
              <div class="row col-12 justify-between q-mb-lg items-center">
                <div>
                  <q-icon size="40px" name="check_circle" color="white" />
                </div>
                <div>
                  <span class="text-h6 text-white">{{
                    highlights.valido
                  }}</span>
                </div>
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Treinamento</div>
        <q-input
          v-model="dados.nomeTreinamento"
          dense
          outlined
          class="input"
          label="Digite o nome do Treinamento"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Status</div>
        <q-select
          v-model="dados.status"
          :options="options.optionsStatus"
          dense
          outlined
          class="select"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Vence Em</div>
        <q-input
          v-model="dados.venceEm"
          dense
          outlined
          class="input"
          placeholder="Dias"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Presença Confirmada</div>
        <q-select
          v-model="dados.presenca"
          :options="options.optionsPresenca"
          dense
          outlined
          class="select"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">GHE</div>

        <div class="col-md-4">
          <q-select
            outlined
            dense
            v-model="dados.ghe"
            :options="funcoes"
            option-value="id"
            behavior="menu"
            map-options
            label="Digite o GHE"
            use-input
            option-label="name"
            @filter="filtrarGhe"
          >
          </q-select>
        </div>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Cargo</div>
        <q-input
          v-model="dados.cargo"
          dense
          outlined
          class="input"
          label="Digite o Cargo"
        />
      </div>
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Centro de Custo</div>

        <q-select
          v-model="dados.centroCusto"
          option-label="name"
          option-value="code"
          label-color="grey-6"
          :options="centroOptions"
          label="Pesquise o Centro de Custo"
          dense
          outlined
          input-debounce="0"
          @filter="filtrarCentro"
          use-input
        />
      </div>
      <div>
        <p></p>
        <q-btn
          label="Filtrar"
          icon="filter_alt"
          color="primary"
          no-caps
          class="q-mt-sm btn"
          @click="listarTreinamentoStatus()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 justify-end q-mb-md">
        <q-btn
          no-caps
          label="Exportar"
          color="secondary"
          icon="file_upload"
          class="btn"
          @click="exportarRelatorio()"
        />
      </div>
      <div class="row col-12 q-my-lg justify-between items-center">
        <span
          class="texto-titulo-tabela text-brand-5 text-subtitle1 text-weight-bold"
        >
          Lista de Treinamentos
        </span>
        <div
          class="row col-12 justify-end text-brand-5 text-weight-bold q-mb-sm container-input-search"
        >
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="dados.funcionario"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </div>
      </div>
      <q-table
        :columns="columns"
        :rows="listaTreinamentos"
        :loading="loading"
        color="primary"
        table-header-class="bg-accent text-weight-bold"
        flat
        class="tabela-tamanho-fixo"
        dense
        hide-bottom
        :grid="$q.screen.lt.sm"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-8">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{ props.row.funcionarioNome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Função: </strong>
                    {{ props.row.funcionarioFuncao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Matricula: </strong>
                    {{ props.row.funcionarioSap }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Email: </strong>
                    {{ props.row.funcionarioEmail }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Treinamento: </strong>
                    {{ props.row.treinamentoNome }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Validade: </strong>
                    {{
                      props.row.treinamentoValidade == 1
                        ? `${props.row.treinamentoValidade} Dia`
                        : `${props.row.treinamentoValidade} Dias`
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Realizado Em: </strong>
                    {{ props.row.treinamentoDataRealizacao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Valido Até: </strong>
                    {{ props.row.treinamentoDataExpiracao }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Confirmado: </strong>
                    {{
                      props.row.funcionarioPresenca == 1 ? "Sim" : "Não"
                    }}</span
                  >
                  <div class="row col-12 q-ml-sm q-mt-sm">
                    <span class="q-mr-xs row items-center"
                      ><strong class="q-mr-xs">Status: </strong>
                      <div
                        v-if="props.row.treinamentoStatus == 'valido'"
                        class="elipse q-mr-sm bg-positive"
                      />
                      <div v-else class="elipse q-mr-sm bg-red" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-funcao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioFuncao }}
          </q-td>
        </template>
        <template v-slot:body-cell-matricula="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioSap }}
          </q-td>
        </template>
        <template v-slot:body-cell-email="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioEmail }}
          </q-td>
        </template>
        <template v-slot:body-cell-treinamento="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentoNome }}
          </q-td>
        </template>
        <template v-slot:body-cell-validade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.treinamentoValidade == 1
                ? `${props.row.treinamentoValidade} Dia`
                : `${props.row.treinamentoValidade} Dias`
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-realizadoEm="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentoDataRealizacao }}
          </q-td>
        </template>
        <template v-slot:body-cell-validoAte="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.treinamentoDataExpiracao }}
          </q-td>
        </template>
        <template v-slot:body-cell-confirmado="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.funcionarioPresenca == 1 ? "Sim" : "Não" }}
          </q-td>
        </template>
        <template v-slot:body-cell-status="props">
          <q-td :props="props">
            <div
              v-if="props.row.treinamentoStatus == 'valido'"
              class="row align items-center"
              style="width: fit-content; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "funcao",
    label: "Função",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matricula",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
  {
    name: "treinamento",
    label: "Treinamento",
    align: "left",
  },
  {
    name: "validade",
    label: "Validade",
    align: "left",
  },
  {
    name: "realizadoEm",
    label: "Realizado Em",
    align: "left",
  },
  {
    name: "validoAte",
    label: "Válido Até",
    align: "left",
  },
  {
    name: "confirmado",
    label: "Confirmado",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const dados = ref({
      nomeTreinamento: "",
      funcionario: "",
      venceEm: "",
      status: {
        label: "Todos",
        value: "todos",
      },
      presenca: {
        label: "Todos",
        value: "",
      },
      ghe: "",
      centroCusto: "",
      cargo: "",
    });
    const options = {
      optionsStatus: [
        {
          label: "Todos",
          value: "todos",
        },
        {
          label: "Vencido",
          value: "vencido",
        },
        {
          label: "Válidos",
          value: "valido",
        },
        {
          label: "Vence Em",
          value: "venceEm",
        },
      ],
      optionsPresenca: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Confirmados",
          value: 1,
        },
        {
          label: "Não Confirmados",
          value: 0,
        },
      ],
    };
    const listaTreinamentos = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    const centroOptions = ref([]);
    const time = ref(null);
    const funcoes = ref([]);
    const highlights = ref("");

    const listarTreinamentoStatus = async (page = 0, rowsNumber = 10) => {
      await unidade.value.id;
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch(
          "treinamento/listarStatusTreinamento",
          {
            unidadeId: unidade.value.id,
            page: page,
            funcionario: dados.value.funcionario,
            treinamento: dados.value.nomeTreinamento,
            per_page: rowsNumber,
            presencaConfirmada: dados.value.presenca.value,
            status: dados.value.status.value,
            cargo: dados.value.cargo,
            ghe: dados.value?.ghe?.name,
            centroCusto: dados.value?.centroCusto?.name,
          }
        );
        listaTreinamentos.value = response.data.data;
        highlights.value = response.data.highlights;
        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.page = response.data.current_page;
        pagination.value.rowsNumber = response.data.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const exportarRelatorio = async () => {
      try {
        await store.dispatch("treinamento/listarStatusTreinamento", {
          download: "xlsx",
          funcionario: dados.value.funcionario,
          status: dados.value.status.value,
          treinamento: dados.value.nomeTreinamento,
          unidadeId: unidade.value.id,
        });
        quasar.notify({
          message:
            "Seu relatório está sendo processado, você receberá o link para download no seu email em alguns minutos!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao exportar relatório",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getFunctions = async (value) => {
      let response = await store.dispatch("user/getFuncoes", {
        vendor_id: store.state.org.unidadeData.id,
        search: value,
      });
      funcoes.value = response.data.results.data;
    };

    const getCentros = async (val) => {
      const response = await store.dispatch("pkg/getCentrosCustos", {
        search: val,
      });

      centroOptions.value = response.data.results.data;
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
        listarTreinamentoStatus();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarTreinamentoStatus(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => dados.value.funcionario,
      () => {
        listarTreinamentoStatus();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarTreinamentoStatus);

    return {
      columns,
      unidade,
      dados,
      options,
      listarTreinamentoStatus,
      listaTreinamentos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      funcoes,
      centroOptions,
      exportarRelatorio,
      highlights,
      filtrarCentro(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          getCentros(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
      filtrarGhe(val, update) {
        getFunctions(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
.card-1 {
  background: #6391f4;
}
.card-2 {
  background: #e23431;
}
.card-3 {
  background: #58c16d;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .elipse {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    padding: 0px;
    margin: 1px 5px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }

  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
